import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb2d557"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "modal-statement modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Offer ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-evidence-upload modal-content" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Upload Evidence")
], -1))
const _hoisted_7 = { class: "tw-mt-2 tw-mb-4 tw-w-full tw-h-auto tw-flex tw-flex-col tw-gap-4 tw-p-3 tw-box-border tw-border-[1px] tw-border-[#DFDFDF] tw-border-solid tw-rounded-[8px] tw-bg-[#F8FBFD]" }
const _hoisted_8 = { class: "upload__section md:!tw-h-[100px]" }
const _hoisted_9 = { class: "uploade-wrapper custom-file-upload !tw-h-[97px] md:!tw-h-full !tw-w-full !tw-mt-4 !tw-rounded-lg tw-border-[rgba(0,0,0,0.4)] tw-border-[1px] tw-border-dashed !tw-mb-4" }
const _hoisted_10 = { class: "attachment-list !tw-mt-0" }
const _hoisted_11 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_12 = { class: "modal-footer" }

import { ref } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import PdfIcon from "@/core/components/icons/PdfIcon.vue";
import ImageIcon from "@/core/components/icons/ImageIcon.vue";
import Text from "@/core/components/ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MakeDisputeOfferModel',
  props: {
  disputeData: {
    type: Object,
    default: null,
  },
},
  emits: ["on-close", "on-submit"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;
const props = __props;

const internalInstance = getCurrentInstance();
const formRef = ref<any>(null);
const isUploadImg = ref<boolean>(false);

const validation = ref({
  offer: [(v: string) => !!v || "Enter your offer required"],
  attachments: [
    (v: any[]) => v.length > 0 || "At least one attachment is required",
  ],
});

const offerDescription = ref<string>("");

const selectedDocuments = ref<any[]>([]);

const onFileChange = (event: any) => {
  const files = event.target.files;
  if (files && files.length > 0) {
    Array.from(files).forEach((file: any) => {
      if (!selectedDocuments.value.some((doc) => doc.name === file.name)) {
        selectedDocuments.value.push(file);
      }
    });
  }

  event.target.value = "";
};

const onSubmit = async () => {
  const isFormValid = await formRef.value.validate();

  if (!isFormValid.valid) return;

  try {
    isUploadImg.value = true;
    const attachments = [] as any;
    for (const attachment of selectedDocuments.value) {
      const formData = new FormData();
      formData.append("file", attachment);
      const uploadImg = await store.dispatch(
        `${USER_STORE}/uploadProfileImage`,
        formData
      );

      if (uploadImg?.publicUrl) {
        attachments.push(uploadImg.attachment);
      } else {
        displayToastMessage(
          internalInstance,
          "Failed to upload an attachment.",
          "error"
        );
      }
    }
    const payload = {
      description: offerDescription.value,
      attachment: attachments,
      disputeIssueId: props.disputeData?.id,
    };

    const response = await store.dispatch(
      `${PROJECT_STORE}/makeDisputeProjectOffer`,
      payload
    );
    const userMessageContent = offerDescription.value;
    const disputeOffer = response.data;
    emits("on-submit", { userMessageContent, disputeOffer });
  } catch (error: any) {
    if (error.response) {
      if (error.response.status) {
        const errorMessage =
          error.response.data.message || "An error occurred. Please try again.";
        displayToastMessage(internalInstance, errorMessage, "error");
      } else {
        // Handle other status codes or errors
        displayToastMessage(
          internalInstance,
          `Error: ${error.response.statusText}`,
          "error"
        );
      }
    } else {
      displayToastMessage(
        internalInstance,
        "The request took too long and timed out. Please try again later.",
        "error"
      );
    }
  } finally {
    isUploadImg.value = false;
    selectedDocuments.value = [];
    offerDescription.value = "";
  }
};

const removeAttachment = (index: number) => {
  selectedDocuments.value.splice(index, 1);
};

const onClickBackButton = () => {
  return emits("on-close");
};

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal !tw-gap-0",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    width: "588px",
    borderRadius: "20px",
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: true,
    headerTitle: "Make an Offer",
    headerDescription: "You may propose an offer to the counter party for the dispute resolution.",
    headerDescriptionTextSize: "h6",
    headerDescriptionLineHeight: "20px",
    gap: "0"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_v_textarea, {
                    class: "input_field",
                    placeholder: "Type your offer here",
                    variant: "solo",
                    rows: "5",
                    "bg-color": "#f8fbfd",
                    autogrow: "",
                    modelValue: offerDescription.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((offerDescription).value = $event)),
                    rules: validation.value.offer
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_v_file_input, {
                        class: _normalizeClass(["upload_file !tw-mb-0 !tw-bg-white", {
                        'added-img':
                          selectedDocuments.value && selectedDocuments.value?.length,
                      }]),
                        label: "Drag and drop images & files, or Browse",
                        multiple: "",
                        variant: "solo-filled",
                        modelValue: selectedDocuments.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDocuments).value = $event)),
                        rules: validation.value.attachments,
                        onChange: onFileChange,
                        "prepend-icon": "mdi-file-image-box"
                      }, null, 8, ["modelValue", "rules", "class"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedDocuments.value, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "attachment-item !tw-bg-none !tw-p-0 !tw-border-none"
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          (file.type === 'application/pdf')
                            ? (_openBlock(), _createBlock(PdfIcon, {
                                key: 0,
                                class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                              }))
                            : (_openBlock(), _createBlock(ImageIcon, {
                                key: 1,
                                class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                              })),
                          _createVNode(Text, {
                            variant: "p",
                            textWeight: "400"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(file.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createVNode(_component_v_icon, {
                          class: "cursor-pointer !tw-text-[16px]",
                          icon: "mdi-close",
                          onClick: ($event: any) => (removeAttachment(index))
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onClickBackButton,
                  disabled: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  onClick: onSubmit,
                  loading: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Submit Offer ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})